import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';

import { useTheme } from '../ThemeContext';

import { Bars3Icon, XMarkIcon, SunIcon, MoonIcon } from '@heroicons/react/24/outline';

const Navbar = () => {
    const [nav, setNav] = useState(false);
    const handleClick = () => setNav(!nav);
    const handleResize = () => {
        if (window.innerWidth >= 768) {
        setNav(false);
        }
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => {
        window.removeEventListener('resize', handleResize);
        };
    }, []);

    const { isDarkMode, toggleTheme } = useTheme();

    return (
        <nav
            className={`bg-amber-100 shadow-[0.625rem_0.625rem_0.875rem_0_rgb(225,226,228),-0.5rem_-0.5rem_1.125rem_0_rgb(255,255,255)] rounded-lg fixed w-full z-20 transition-all duration-500 ease-in-out
            ${nav ? 'h-screen md:pt-10' : 'h-20 md:top-10 md:left-1/2 md:h-fit md:transform md:-translate-x-1/2 md:w-3/4 md:rounded-lg'}`}>
            <div className="max-w-screen-xl flex flex-wrap justify-between mx-auto p-4">
                <a href="/" className="flex items-center">
                    <span className="self-center text-3xl text-slate-800 font-semibold whitespace-nowrap">Keebs</span>
                </a>
                <div className="flex items-center md:order-2">
                    <button type="button"
                        className="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-slate-800 rounded-lg hover:bg-amber-200 focus:ring-2 focus:ring-amber-500 transition-all duration-400 ease-in-out"
                        onClick={toggleTheme}
                    >{isDarkMode ? <SunIcon className="h-10 w-10" /> : <MoonIcon className="h-10 w-10" />}
                    </button>
                    <button
                        type="button"
                        className="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-slate-800 md:hidden rounded-lg hover:bg-amber-200 focus:ring-2 focus:ring-amber-500 transition-all duration-400 ease-in-out"
                        onClick={handleClick}
                    >{!nav ? <Bars3Icon className="h-5 w-5" /> : <XMarkIcon className="h-5 w-5"></XMarkIcon>}
                    </button>
                </div>
                <div className="items-center justify-between hidden w-full md:flex md:w-auto md:order-1">
                    <ul className="flex flex-row font-medium space-x-6">
                    <li>
                        <NavLink to="/" className={({ isActive }) =>
                        (isActive ? "block py-2 px-3 font-bold shadow-[0.625rem_0.625rem_0.875rem_0_rgb(225,226,228),-0.5rem_-0.5rem_1.125rem_0_rgb(255,255,255)] rounded" : "block py-2 px-3 text-slate-800 rounded hover:shadow-[0.625rem_0.625rem_0.875rem_0_rgb(225,226,228),-0.5rem_-0.5rem_1.125rem_0_rgb(255,255,255)]")}>Home</NavLink>
                    </li>
                    <li>
                        <NavLink to="/calendar" className={({ isActive }) =>
                        (isActive ? "block py-2 px-3 font-bold shadow-[0.625rem_0.625rem_0.875rem_0_rgb(225,226,228),-0.5rem_-0.5rem_1.125rem_0_rgb(255,255,255)] rounded" : "block py-2 px-3 text-slate-800 rounded hover:shadow-[0.625rem_0.625rem_0.875rem_0_rgb(225,226,228),-0.5rem_-0.5rem_1.125rem_0_rgb(255,255,255)]")}>Calendar</NavLink>
                    </li>
                    <li>
                        <a href="https://docs.google.com/forms/d/e/1FAIpQLScQbpTPHsp01XUQg-fZWRbnxY4t62hcsxjTE1IKfZFiIW6yJQ/viewform" className="block py-2 px-3 text-slate-800 rounded hover:shadow-[0.625rem_0.625rem_0.875rem_0_rgb(225,226,228),-0.5rem_-0.5rem_1.125rem_0_rgb(255,255,255)]">Tickets</a>
                    </li>
                    <li>
                        <NavLink to="/links" className={({ isActive }) =>
                        (isActive ? "block py-2 px-3 font-bold shadow-[0.625rem_0.625rem_0.875rem_0_rgb(225,226,228),-0.5rem_-0.5rem_1.125rem_0_rgb(255,255,255)] rounded" : "block py-2 px-3 text-slate-800 rounded hover:shadow-[0.625rem_0.625rem_0.875rem_0_rgb(225,226,228),-0.5rem_-0.5rem_1.125rem_0_rgb(255,255,255)]")}>Links</NavLink>
                    </li>
                    </ul>
                </div>
            </div>

            <div className={`transition-all duration-500 ease-in-out text-6xl font-medium ${!nav ? 'hidden' : ''}`}>
                <ul>
                    <li>
                        <NavLink to="/" className={({ isActive }) =>
                        (isActive ? "block py-2 pl-3 pr-4 font-bold shadow-[0.625rem_0.625rem_0.875rem_0_rgb(225,226,228),-0.5rem_-0.5rem_1.125rem_0_rgb(255,255,255)] rounded" : "block py-2 pl-3 pr-4 text-slate-800 rounded hover:bg-slate-600")}
                        onClick={handleClick}
                        >Home</NavLink> 
                    </li>
                    <li>
                        <NavLink to="/calendar" className={({ isActive }) => 
                        (isActive ? "block py-2 pl-3 pr-4 font-bold shadow-[0.625rem_0.625rem_0.875rem_0_rgb(225,226,228),-0.5rem_-0.5rem_1.125rem_0_rgb(255,255,255)] rounded" : "block py-2 pl-3 pr-4 text-slate-800 rounded hover:bg-slate-600")}
                        onClick={handleClick}
                        >Calendar</NavLink>
                    </li>
                    <li>
                        <a href="https://docs.google.com/forms/d/e/1FAIpQLScQbpTPHsp01XUQg-fZWRbnxY4t62hcsxjTE1IKfZFiIW6yJQ/viewform" className="block py-2 pl-3 pr-4 text-slate-800 rounded hover:bg-slate-600" 
                        onClick={handleClick}
                        >Tickets</a>
                    </li>
                    <li>
                        <NavLink to="/links" className={({ isActive }) => 
                        (isActive ? "block py-2 pl-3 pr-4 font-bold shadow-[0.625rem_0.625rem_0.875rem_0_rgb(225,226,228),-0.5rem_-0.5rem_1.125rem_0_rgb(255,255,255)] rounded" : "block py-2 pl-3 pr-4 text-slate-800 rounded hover:bg-slate-600")}
                        onClick={handleClick}
                        >Links</NavLink>
                    </li>

                </ul>
            </div>
        </nav>
    )
} 

export default Navbar;